"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _rcSlider = _interopRequireWildcard(require("rc-slider"));

var _overrides = require("../../../utils/overrides");

var _Label = _interopRequireDefault(require("../Label"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Slider');
var Handle = _rcSlider.default.Handle;

function Slider(_ref) {
  var _classnames;

  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      value = _ref.value,
      label = _ref.label,
      labelMode = _ref.labelMode,
      isFullWidth = _ref.isFullWidth,
      hint = _ref.hint,
      error = _ref.error,
      isRequired = _ref.isRequired,
      isReadOnly = _ref.isReadOnly,
      isRange = _ref.isRange,
      min = _ref.min,
      max = _ref.max,
      step = _ref.step,
      tipFormatter = _ref.tipFormatter,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "value", "label", "labelMode", "isFullWidth", "hint", "error", "isRequired", "isReadOnly", "isRange", "min", "max", "step", "tipFormatter"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // State

  var _useState = (0, _react.useState)(isRange && value === undefined ? [min, max] : value || 0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      innerValue = _useState2[0],
      setInnerValue = _useState2[1]; // Overrides


  var override = (0, _overrides.getOverrides)(overridesProp, Slider.overrides); // Classes

  var rootClassName = (0, _classnames2.default)(classes.root, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes.isReadOnly, isReadOnly), (0, _defineProperty2.default)(_classnames, classes[labelMode], labelMode), (0, _defineProperty2.default)(_classnames, classes.isFullWidth, isFullWidth), (0, _defineProperty2.default)(_classnames, classes.errored, error), _classnames), classNameProp);
  var rootProps = {
    className: rootClassName
  };
  var labelProps = (0, _extends2.default)({
    className: classes.Label,
    isRequired: isRequired,
    hint: hint
  }, override.Label); // Tip element

  var handle = (0, _react.useCallback)(function (props) {
    var offset = props.offset,
        dragging = props.dragging,
        index = props.index,
        restProps = (0, _objectWithoutProperties2.default)(props, ["offset", "dragging", "index"]);
    var positionStyle = {
      left: "".concat(offset, "%")
    };
    var handlerValue = Array.isArray(innerValue) ? innerValue[index] : innerValue;
    var finalValue = tipFormatter ? tipFormatter(handlerValue) : handlerValue;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      key: index,
      className: classes.overlay
    }, override.overlay), /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
      style: positionStyle,
      className: classes.overlayLabel
    }, override.overlayLabel), finalValue), /*#__PURE__*/_react.default.createElement(Handle, (0, _extends2.default)({
      value: innerValue,
      offset: offset
    }, restProps, {
      className: classes.overlayHandler,
      prefixCls: "hoi-poi-slider",
      dragging: dragging.toString()
    })));
  }, [classes.overlay, classes.overlayHandler, classes.overlayLabel, innerValue, override.overlay, override.overlayLabel, tipFormatter]); // Avoiding re-renderings

  var onChange = (0, _react.useCallback)(function (value) {
    setInnerValue(value);
  }, []);
  var sliderProps = (0, _extends2.default)({
    className: classes.slider,
    value: innerValue,
    onChange: onChange,
    onAfterChange: (0, _react.useCallback)(function () {
      props.onBlur && props.onBlur.apply(props, arguments);
    }, [props]),
    disabled: isReadOnly,
    max: max,
    min: min,
    step: step,
    defaultValue: isRange ? [min, max] : min,
    handle: handle
  }, override['rc-slider']);
  var Component = isRange ? _rcSlider.Range : _rcSlider.default;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rootProps, override.root), label && /*#__PURE__*/_react.default.createElement(_Label.default, labelProps, label), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.formControl
  }, override.formControl), /*#__PURE__*/_react.default.createElement(Component, sliderProps), error && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.error
  }, override.error), error)));
}

Slider.overrides = ['root', 'rc-slider', 'error', 'formControl', 'Label', 'overlay', 'overlayLabel'];
Slider.defaultProps = {
  overrides: {},
  labelMode: 'horizontal',
  onChange: function onChange() {},
  isReadOnly: false,
  max: 100,
  min: 0,
  step: 1,
  isRange: false
};
process.env.NODE_ENV !== "production" ? Slider.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  label: _propTypes.default.string,
  labelMode: _propTypes.default.oneOf(['horizontal', 'vertical']),
  value: _propTypes.default.any,
  onChange: _propTypes.default.func,
  isFullWidth: _propTypes.default.bool,
  isRange: _propTypes.default.bool,

  /** Info popover */
  hint: _propTypes.default.string,

  /** Error will be displayed below the component with style changes */
  error: _propTypes.default.string,
  isReadOnly: _propTypes.default.bool,

  /** A function to format tooltip\'s overlay */
  tipFormatter: _propTypes.default.func,

  /** The maximum value of the slider */
  max: _propTypes.default.number,

  /** The minimum value of the slider */
  min: _propTypes.default.number,

  /** Value to be added or subtracted on each step the slider makes. Must be greater than zero, and max - min should be evenly divisible by the step value.  */
  step: _propTypes.default.number
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Slider);

exports.default = _default;